import { Component, OnInit, NgZone, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import notify from 'devextreme/ui/notify';
import { NgForm, FormBuilder, FormGroup } from '@angular/forms';
import { User } from '../../shared/models/users';
import { Company } from '../../shared/models/companies';
import { DetailUsers } from 'src/app/shared/models/detailUsers';
import { UsersService } from 'src/app/shared/services/users.service';
import { CompaniesService } from 'src/app/shared/services/companies.service';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import { ProgramsService } from 'src/app/shared/services/programs.service';
import { Program } from 'src/app/shared/models/programs';
import { CardsService } from 'src/app/shared/services/cards.service';
import { CacaoService } from 'src/app/shared/services/cacao.service';
import { DxDataGridModule } from 'devextreme-angular';
import { exportDataGrid } from 'devextreme/excel_exporter';
import * as ExcelJS from "exceljs/dist/exceljs.min.js";
import * as FileSaver from "file-saver";
import saveAs from 'file-saver';
import { ExcelService } from './../../shared/services/excel.service';
@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.scss']
})
export class UserDetailComponent implements OnInit {
  public userSelected: any;

  /**********************/
  subscriptions: Subscription[] = [];
  usersProviders = [];
  companiesList: Company[] = [];
  tempUserObj: any;
  tempCompanyObj: any;
  programId: string;
  programData: Program;
  emailDisabled: boolean;
  companyId: string;
  details: DetailUsers;
  usersList: any = [];
  udta: any;
  companyData: Company;
  @ViewChild('form') form: NgForm;
  uploadForm: FormGroup;
  genderOptions = [
    { name: 'Masculino', val: 'M' },
    { name: 'Femenino', val: 'F' },
  ]
  cdta: any;
  tempBirthDate: any;
  phone: any;
  popupVisible = false;
  popupVisibleNip = false;
  popupVisibleEmail = false;
  tarjeta: string;
  cvv: string;
  expirationDate: string;
  userEmail : any;
  email: string;

  newNIP: string;

  accent: any = /^([à-ú]|[À-Ú])+$/;
  secondNameValue: string;

  // Loading
  loadingPosition: any;
  loadingVisible: boolean = false;

  constructor(
    private usersService: UsersService,
    private utilitiesService: UtilitiesService,
    private route: ActivatedRoute,
    private companiesService: CompaniesService,
    private router: Router,
    private ngZone: NgZone,
    private formBuilder: FormBuilder,
    private programsService: ProgramsService,
    private cardService: CardsService,
    private cacaoService: CacaoService,
    private excelService:ExcelService,
  ) {
    // Get ID from URL
    if (this.route.snapshot.params['programId']) {
      this.programId = this.route.snapshot.params['programId'];
      //Lo voy a tomar del local storage
      this.companyId = this.route.snapshot.params['companyId'];
    } else {
      this.details = new DetailUsers();
    }
    this.udta = this.utilitiesService.getUserData();
    this.onClickDetail = this.onClickDetail.bind(this);  
  }

  ngOnInit(): void {
    this.uploadForm = this.formBuilder.group({
      profile: ['']
    });
    this.subscriptions.push(
      this.companiesService.getCompanies().subscribe(companies => {
        this.companiesList = companies;
      }),
      this.companiesService.getCompany(this.companyId).subscribe(company => {
        this.companyData = company;
        // console.log(this.companyData);

      }),
      this.usersService.getBeneficiaries({ idProgram: this.programId, companyId: this.companyId })
        .subscribe(detailProgram => {
          if (detailProgram.users.length >= 1) {
            this.usersList = detailProgram.users;
            console.log('usuarios: ',this.usersList);
          }
        }),
      this.programsService.getProgram(this.programId).subscribe(program => {
        this.programData = program;
        // console.log(this.programData);
      })
    );
    this.cdta = this.utilitiesService.getCompanyData();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe);
  }

  // Funcion al oprimir el boton para agregar un nuevo usuario 
  onInitNewRow(e) {
    this.emailDisabled=false;
    this.tempBirthDate='';
    e.data = new User;
  }

  disableFields(e){
    this.tempBirthDate=e.data.birthDate;
    this.phone = e.data.phone;
    this.emailDisabled=true;
    console.log(e.data);
  }

  showInfo(event, user?) {
    this.userSelected = user.data;
    this.popupVisible = true;
  }
  onClickDetail(e) {
    console.log(e);
    e.event.preventDefault();
    const data = e.row.data;
    this.router.navigate(['dash','users','detail',data.id]);    
  }
  getCardNumber(e,row) {
    console.log(row);
    this.utilitiesService.decryptCard(row.data.program[0].card.cardNumber).toPromise()
    .then((result: any) => {
      console.log(result);
      let _cardNumber: string = result.cardNumber.trim();
      row.data.program[0].card.Tarjeta = this.cardNumberFormat(_cardNumber);
    })
    .catch(error => {
      console.log(error);
    });
  }
  cardNumberFormat(cn: string) {
    return cn.substring(0,4)+' '+cn.substring(4,8)+' '+cn.substring(8,12)+' '+cn.substring(12,16);
  }
  getNip(e,row) {
    console.log(row);
    this.cacaoService.ConsultarNIP(row.data.program[0].card.cardNumber).toPromise()
    .then((result: any) => {
      console.log(result);
      row.data.program[0].card.NIP = result.data.NIP;
    })
    .catch(error => {
      console.log(error);
    });
  }

  addCard(event, user?) {
    this.userSelected = user.data;
    this.popupVisible = true;
  }

  activateCard(e){
    console.log(e);
    console.log(this.tarjeta);
    console.log(this.userSelected);
    this.loadingVisible = true;
    this.loadingPosition = { of: '#popupCardActivate' };
    this.cardService.runActivateCardUser(this.userSelected,{cardNumber: this.tarjeta}, this.programId)
    .then((res: any) => {
      console.log(res);
      if(res && !res.error) {
        let index = this.usersList.indexOf(this.userSelected);
        console.log(index);
        this.usersList[index] = res.user;
        this.userSelected = null;
        this.popupVisible = false;
        notify('Se ha activado la tarjeta con éxito', 'success', 1000);
      } else {
        console.log('ERROR: ', res.error.message);
        notify(res.error.message, 'danger', 1000);
      }
    })
    .catch(err => {
      console.log(err);
    }).finally(() => {
      this.loadingVisible = false;
    });
    this.tarjeta='';
  }


  showUpdateNip(event) {
    console.log(event);
    console.log(this.userSelected.id, this.userSelected.program[0].card.cardNumber, this.newNIP);
    this.loadingVisible = true;
    this.loadingPosition = { of: '#popupCardActivate' };
    this.cardService.updateNIP(this.userSelected.id, this.userSelected.program[0].card.cardNumber, this.newNIP).toPromise()
    .then((res: any) => {
      console.log(res);
      if(res && !res.error) {
        let index = this.usersList.indexOf(this.userSelected);
        this.usersList[index] = res.user;
        this.userSelected = null;
        this.popupVisible = false;
        notify('Se ha actualizado el NIP de la tarjeta con éxito', 'success', 1000);
      } else {
        notify(res.error.message, 'danger', 1000);
      }
    })
    .catch(err => {
      console.log(err);
      //notify('', 'danger', 1000);
    }).finally(() => {
      this.loadingVisible = false;
    });
  }

   async showUpdateUserEmail(event) {
    console.log(event);
    console.log(this.userSelected);
    
    this.usersService.updateEmail(this.userSelected.id, this.userSelected.email).toPromise()
    .then(res => {
      if(res.error) {
        notify(res.error.message, 'danger', 1000);
      } else {
        notify('Se ha actualizado con éxito el Email, y se envio un correo electronico con la información para iniciar sesión', 'success', 1000);
      }
    })
    .catch(error => {
      console.log('ERROR');
      console.log(error);
    });
    
    //this.userEmail.email = this.email;
    //this.userEmail.appUser = true;
    
    /*
    this.usersService.userAddAuth(this.userEmail).subscribe(res => {
    }), (error => {
      this.utilitiesService.notifyMe(error, 'error');
    });
    */

    /*
    await this.usersService.updateUser(this.userEmail).subscribe(res => {
      //this.utilitiesService.notifyMe('', 'success');
    }), (error => {
      this.utilitiesService.notifyMe(error, 'error');
    });
    */

    // Vincular la Información del Usuario con la Tarjeta(Cacao)
    /*
    console.log(this.userEmail);
    let _ActualizarDatosCliente: any = this.cacaoService.ActualizarDatosCliente(this.tarjeta,this.userEmail).toPromise();
    console.log(_ActualizarDatosCliente);
    if(!_ActualizarDatosCliente || _ActualizarDatosCliente.error){
      throw _ActualizarDatosCliente;
    }
    */

    this.popupVisibleEmail = false;
    this.email = '';
    this.userSelected = null;
  
  }

  updateNip(event,user){
    console.log(user);
    this.userSelected = user.data;
    this.popupVisibleNip = true;
  }

  updateUserEmail(event,user){
    //this.userEmail = user.data;
    this.userSelected = user.data;
    this.popupVisibleEmail = true;
  }

  updateCardNIP(e) {
    this.loadingVisible = true;
    this.loadingPosition = { of: '#popupCardActivate' };
    console.log(e);
    console.log(this.userSelected.id,this.userSelected.program[0].card.cardNumber,this.newNIP);
    this.cardService.updateNIP(this.userSelected.id,this.userSelected.program[0].card.cardNumber,this.newNIP).toPromise()
    .then((res: any) => {
        console.log(res);
        if(res && !res.error) {
          let index = this.usersList.indexOf(this.userSelected);
          //this.usersList[index] = res.user;
          this.userSelected = null;
          this.popupVisibleNip = false;
          notify('Se ha actualizado el NIP de la tarjeta con éxito', 'success', 1000);
        } else {
          notify(res.error.message, 'danger', 1000);
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.loadingVisible = false;
      });
  }

  onExporting(e) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('User');
    let userListExport : any[] =  [];
    this.usersList.forEach(function (user) {
      let userCurrent = {Nombre : '', 'Primer apellido':'', 'Segundo apellido': '', 'e-mail': '',
                        'Tarjeta': '','NIP': ''};
      let middleName = user.middleName != undefined ? user.middleName : '';
      let tarjeta = user.program[0].card ? '**** **** **** ' + user.program[0].card.number : '';
      let nip = user.program[0].card != undefined ? user.program[0].card.NIP : '';
      userCurrent.Nombre = user.name + ' ' + middleName;
      userCurrent['Primer apellido'] = user.lastName;
      userCurrent['Segundo apellido']= user.secondLastName;
      userCurrent['e-mail']= user.email;
      userCurrent['Tarjeta']= tarjeta;
      userCurrent['NIP']=nip;
      userListExport.push(userCurrent);
      userCurrent=null;
    });
    this.excelService.exportAsExcelFile(userListExport,'usuarios');
  }

  addNewUser(e) {
    const newUserData = e.data;
    console.log('registro individual : ' + JSON.stringify(newUserData));
    newUserData.companyName = this.companyData.companyName;
    newUserData.companyId = this.companyData.id;
    newUserData.active = true;
    newUserData.belongsToIhunterProgram = false;
    newUserData.belongsToProgram = true;
    newUserData.dateCreated = this.utilitiesService.dateToNumber(new Date());
    // tslint:disable-next-line:max-line-length
    newUserData.birthDate = this.tempBirthDate.getFullYear() + '-' + ('0' + (this.tempBirthDate.getMonth() + 1)).slice(-2) + '-' + ('0' + this.tempBirthDate.getDate()).slice(-2);
    newUserData.level = 5;

    if (this.programId != undefined && this.companyId != undefined) {
      newUserData.programIdTemporal = this.programId;
    }
    if(this.companyData.userWithNoApp){
      this.usersService.newUserWithoutApp(newUserData).subscribe(res => {
        this.utilitiesService.notifyMe('Ejecutado exitosamente!', 'success');
      });
    }else{
      this.usersService.newUser(newUserData).subscribe(res => {
        this.utilitiesService.notifyMe('Ejecutado exitosamente!', 'success');
      });
    }
  }

  updateUser(e) {
    const newUserData = e.newData;
    newUserData.id = e.oldData.id;
    this.usersService.updateUser(newUserData).subscribe(res => {
      this.utilitiesService.notifyMe('Ejecutado exitosamente!', 'success');
    });
  }

  deleteData(e) {
    this.usersService.deleteUserApi(e).subscribe(res => {
      this.utilitiesService.notifyMe('Usuario eliminado exitosamente!', 'success');
    });
  }

  checkForCompany(e) {
    const selectedCompany = this.companiesList.filter(company => company.id === e);
    this.tempCompanyObj = selectedCompany[0];
  }

  fileupload(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.uploadForm.get('profile').setValue(file);
    }
  };

  onSubmitFileCsv() {
    const formData = new FormData();
    formData.append('file', this.uploadForm.get('profile').value);
    formData.append('idProgram', this.programId);
    formData.append('idCompany', this.companyId);
    console.log('---:' , this.companyData.userWithNoApp);
    if(this.companyData.userWithNoApp){
      console.log('Usuarios sin app ');
      this.usersService.uploadUsersCsvWithoutApp(formData).subscribe(res => {
        this.utilitiesService.notifyMe('Ejecutado exitosamente!', 'success');
      });
    }else{
      console.log('Usuarios con app ');
      /*this.usersService.uploadUsersCsv(formData).subscribe(res => {
        this.utilitiesService.notifyMe('Ejecutado exitosamente!', 'success');
      });*/
    }
    //location.reload();
  }

  cleanString(e){
    const characters='.áéíóúÁÉÍÓÚÑñ-_ ';
    let result = false;
    for (let i = 0; i < e.value.length; i++) {
      const character = e.value.charAt(i);
        for(let y=0; y < characters.split('').length ; y++){
          if(character===characters.charAt(y)){
            result=false;
            break;
          }else{
             result=true;
          }
        }
        if(!result){
          break;
        }
    }
    return result;
  }

  closePopup(popup) {
    switch(popup) {
      case 'email': this.popupVisibleEmail = false;
      case 'card': this.popupVisible = false;
      case 'nip': this.popupVisibleNip = false;
    }
    this.userSelected = null;
  }
  

  onShowLoadingPanel(e) {}

  onHideLoadingPanel(e) {}

  
}